export class GameSession {
  private manualPaused = false
  private lifecyclePaused = false

  booms = 0
  level = 1
  levelCleared = false
  gameOver = false

  get paused(): boolean {
    return this.manualPaused || this.lifecyclePaused || this.levelCleared || this.gameOver
  }

  get pauseReason(): 'manual' | 'lifecycle' | 'level' | 'game-over' | null {
    if (this.levelCleared) return 'level'
    if (this.gameOver) return 'game-over'
    if (this.lifecyclePaused) return 'lifecycle'
    if (this.manualPaused) return 'manual'
    return null
  }

  registerBoom(): void {
    this.booms += 1
  }

  toggleManualPause(): boolean {
    this.manualPaused = !this.manualPaused
    return this.paused
  }

  setLifecyclePaused(paused: boolean): void {
    this.lifecyclePaused = paused
  }

  completeLevel(): void {
    this.levelCleared = true
  }

  endGame(): void {
    this.gameOver = true
  }

  advanceLevel(): void {
    if (!this.levelCleared) return
    this.level += 1
    this.restartLevel()
  }

  restartLevel(): void {
    this.booms = 0
    this.manualPaused = false
    this.lifecyclePaused = false
    this.levelCleared = false
    this.gameOver = false
  }

  reset(): void {
    this.level = 1
    this.restartLevel()
  }
}
